/**
 * Build the open-load display model for the URL loadId.
 * Returns null when the load row does not belong to loadId (stale / loading).
 */
export function resolveOpenLoad(parts) {
    const { loadId, load, contact, pay, payLoadId } = parts;
    if (!loadId)
        return null;
    if (!load || load.id !== loadId)
        return null;
    const brokerContact = contact &&
        load.brokerContactId != null &&
        contact.id === load.brokerContactId
        ? {
            id: contact.id,
            name: contact.name,
            phone: contact.phone,
        }
        : null;
    const safePay = pay != null && (payLoadId == null || payLoadId === loadId) ? pay : null;
    return {
        loadId,
        note: load.note,
        brokerContact,
        pay: safePay,
    };
}
//# sourceMappingURL=openLoad.js.map